<template>
    <div class="detailInfo">
        <h3 v-html="info.biaoTi"></h3>
        <div class="detail-content" v-html="toHtml(info.neiRong)"></div>
        <div class="detail-footer">
            <div v-if="prev" @click="onPage(-1)"><span>上一页:</span><a>{{ prev.biaoTi }}</a></div>
            <div v-if="next" @click="onPage(1)"><span>下一页:</span><a>{{ next.biaoTi }}</a></div>
        </div>
    </div>
    <!-- <perfect-scrollbar ref="appScrollbar" :options="{ suppressScrollX: true }">
    </perfect-scrollbar> -->
</template>

<script>
import { mapGetters } from 'vuex';
export default {
    props: {
        bookId: {
            type: String,
            default: ""
        },
        id: {
            type: String,
            default: ""
        },
        bookName: {
            type: String,
            default: ""
        },
        keyword: {
            type: String,
            default: ""
        }
    },
    watch: {
        id() {
            this.getData();
        }
    },
    computed: {
        ...mapGetters(["catalogueList"]),
        bookIndex() {
            return this.catalogueList.findIndex(i => i.id == this.id)
        },
        prev() {
            let index = this.bookIndex - 1;
            return index >= 0 ? this.catalogueList[index] : null;
        },
        next() {
            let index = this.bookIndex + 1;
            return index < this.catalogueList.length ? this.catalogueList[index] : null;
        },
        word() {
            if (this.keyword) {
                let obj = this.common.parseUrlParams(this.keyword);
                return obj.keyword;
            } else {
                return "";
            }
        },
    },
    data() {
        return {
            picView: null,
            info: {},
            picRoot: '',
        };
    },
    methods: {
        onPage(index) {
            clearTimeout(this.djs);
            this.djs = setTimeout(() => {
                if (index > 0) {
                    this.jump(`/bookDetail/${this.bookId}/${this.next.id}/${this.bookName}`)
                } else {
                    this.jump(`/bookDetail/${this.bookId}/${this.prev.id}/${this.bookName}`)
                }
            }, 100);
        },
        toHtml(str) {
            if (!str) return "";
            if (this.keyword) {
                str = this.common.batchHighlightKeyword(str, this.word);
            }
            let picFolder = this.u_config.cloudPic + this.info.picFolder;
            let img = `<img src="${picFolder}/$1" />`;
            return str.replace(/\[alt\].*?\[\/alt\]/ig, "")
                .replace(/\[img\](.*?)\[\/img\]/ig, img)
                .replace(/\[(.*?)\]/ig, '<$1>')
                .split(/\r\n/g)
                .map(i => `<p>${i}</p>`)
                .join("");
        },
        async getData() {
            let obj = {
                bookId: this.bookId, // 书名Id 
                id: this.id, //	书详细的内容Id
            };
            this.info = {};
            this.$store.commit("showLoading");
            await this.api("getBookDetail", obj).then(res => {
                this.$store.commit("hideLoading");
                this.info = res.result[0];
            });

            // 查找目录
            this.$store.dispatch("getBookDetail", {
                bookId: this.bookId, // 书名Id 
            })
        }
    },
    mounted() {
        // eslint-disable-next-line no-undef
        $(document).keydown((event) => {
            if (this.$route.name == 'bookDetail') {
                if (event.keyCode == 37) {
                    if (this.prev) this.onPage(-1);
                } else if (event.keyCode == 39) {
                    if (this.next) this.onPage(1);
                }
            }
        });
        // 复制监听
        document.addEventListener('copy', (e) => {
            if (this.$route.name == 'bookDetail') {
                //取消默认事件，才能修改复制的值
                e.preventDefault();
                //复制的内容
                var copyTxt;
                if (window.getSelection(0).toString().length >= 10) {
                    copyTxt = `${window.getSelection(0).toString()}\n\n--出自${this.bookName} ${this.info.biaoTi}`
                } else {
                    copyTxt = window.getSelection(0).toString();
                }
                if (e.clipboardData) {
                    e.clipboardData.setData('text/plain', copyTxt);
                } else if (window.clipboardData) {
                    return window.clipboardData.setData('text', copyTxt);
                }
            }
        });
    },
    created() {
        this.getData();
    },
}
</script>

<style lang="scss" >
.detailInfo {
    h1 {
        text-align: center;
    }

    p {
        text-indent: 2em;
        padding-bottom: 5px !important;
    }

    @media (max-width: 900px) {
        .detail-content {
            img {
                max-width: 85%;
            }
        }
    }
}
</style>